import { colorToCss, hexToRgbArray } from "../color/color"
import { MaterialColors } from "../color/material"
import { getStandardColors, getSwatches } from "../components/color-picker/cp"
import { Popup, PopupContentProps } from "./Popup"
import { classes } from "./react"

interface ButtonProps extends PickerProps {
    disabled?: boolean
}

export function ColorPickerButton(props: ButtonProps) {

    const { color, disabled } = props

    const getCurrentCssColor = () => color
        ? colorToCss(color)
        : undefined

    return <div className="omnia-color-picker-button" style={{ display: "inline-block " }}>

        <Popup popupContent={ColorPicker} popupContentProps={() => props} disabled={disabled}>

            <button type="button" className="btn btn-default" disabled={disabled}>

                <span className={classes({ c: true, "omnia-color-picker-nofill": !color })} style={{ backgroundColor: getCurrentCssColor() }}>
                </span>

                {
                    (!disabled) &&
                    <>
                        {" "}
                        <span className="caret"></span>
                    </>
                }

            </button>

        </Popup>

    </div>

}

interface PickerProps {

    color?: number[]
    setColor(color: number[]): void

    options?: {
        includeAccentColors?: boolean
        swatches?: string[]
    }

    closeWhenSelected?: boolean

}

export function ColorPicker({ options, setColor, closeWhenSelected, close }: PickerProps & PopupContentProps) {

    const swatches = getSwatches(MaterialColors, options)
    const standard = getStandardColors()

    const selectColor = (c: string) => {
        setColor(c ? hexToRgbArray(c) : null)
        closeWhenSelected && close()
    }

    return <div className="omnia-color-picker">

        <div>

            <div className="palette">

                {
                    swatches.map((swatch, index) => <div key={index} className="swatch">
                        {
                            swatch.map(c =>
                                <div key={c} className="c" style={{ backgroundColor: c, borderColor: c }} onClick={() => selectColor(c)}></div>
                            )
                        }
                    </div>)
                }
            </div>

            <div className="standard">

                {
                    standard.map(c => <div key={c.description} className="c" title={c.description} style={{ backgroundColor: c.color }} onClick={() => selectColor(c.color)}>
                    </div>)
                }
                <div className="c omnia-color-picker-nofill" title="No fill" onClick={() => selectColor(null)}>
                </div>

            </div>

        </div>

    </div>
}
